import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects'
import ProjectsList from "../Projects/ProjectsList";
import Popover from "../../common/components/popover/popover.js";
import {pollImpact} from '../../common/api/impactPoller';
import ProjectsScroll from "../../common/components/Projects/ProjectsScroll";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const LandingPage = ({ merchantCode }) => {
    const [projects, setProjects] = useState();
    const [fetchedImpact, setFetchedImpact] = useState(null);

    useEffect(() => {
        pollImpact(setFetchedImpact,merchantCode);
    }, []);

    
    const numberOfProducts = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.impactProgress?.products?.currentCount);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.impactProgress?.carbonOffset?.currentCount));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(Math.floor(fetchedImpact.impactProgress?.treeGrowthYears?.currentCount));
    
    const treeMetric = treeGrowthYears && <span className="translate-dynamic"><span>An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as </span> <span className="no-translate"> {treeGrowthYears}</span> <span>trees have in one year.</span></span>
        
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    return (
        <div>
            <div>
                <div className="center py-3">
                    <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628576743/Enterprise/inclover/inclover-logo_bg1jkl.svg`} style={{height: '56px'}} />
                </div>
            </div>
            <div className="w-100 position-relative img-cover hero-img vertical-align-parent bg-grey" >
               
                <div className="container text-align-start vertical-align">
                    <div>
                        <div className="mw-448px">
                            <h1 className="mb-4 text-shadow mt-0 text-white">We're creating a better pet supplement company & the best part is, there's nothing to hide.</h1>
                            <p className="mb-3 text-shadow mw-415 font-600 text-white">As part of our commitment to supporting the health of pets, our people, and our planet, InClover donates $0.05 from every purchase to carbon offset programs. Check our live impact dashboard powered by our partners at CarbonClick and read more about our core values and missions below.</p>
                            <p className="mb-3 text-shadow mw-415 font-600 text-white">+500 logged hours on our mission to B Corp certification and counting. Our journey is constantly moving and we want you to be a part of every step.</p>
                        </div>
                        <a href="https://eshop.inclover.com/" className="btn btn-primary my-3">Shop Now</a>
                        <div className="d-flex mobile-hide align-items-center">
                            <p className="mr-2 mt-0 text-white font-600 mb-2">Powered By</p>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 24 }} src={logo} /></a>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center align-items-center">
                        <p className="mr-2 font-bold mt-0 mb-0 text-white font-600">Powered By</p>
                        <div>
                            <a className="d-inline-flex mt-2" target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 24 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="py-6">
                <div className="container text-center">
                    <div className="mb-0 center wugSecHead">
                        <h2 className="font-bold">Watch Us Go</h2>
                        <p className="text-grey mb-0">Our partners at CarbonClick are helping you see the change we’re <br/>committed to in real time with this impact dashboard below</p>
                        <p className="text-grey mb-0">As part of our promise to people, pets and our planet, we’ve focused<br/> our sustainable development goals into three core categories including <br/>responsible consumption & production, decent work & economic growth, and <br/>reducing energy usage & greenhouse gas emissions</p>
                    </div>
                    <div className="mobile-hide">
                        <div className="mw-800px center cBoxes">
                            <div className="row text-align-start m-0">

                                <div className="col-md-4 col-sm-6 d-grid">
                                    <div className="center bg-secondary pattern-2 w-100 pt-5">
                                        <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587366/Enterprise/inclover/cloudy1_r7lsn5.svg`}/></div>
                                        <div className="px-2 pt-2">
                                            <h3 className="font-bold">{carbonOffsetImpact}</h3>
                                            <p className="mt-0 font-bold">{carbonOffsetImpactUnit}, of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6 d-grid">
                                    <div className="center bg-secondary pattern-2 w-100 pt-5">
                                        <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/pet1_oqxzin.svg`} /></div>
                                        <div className="px-2 pt-2">
                                            <h3 className="font-bold">{numberOfProducts}</h3>
                                            <p className="mt-0 font-bold">Climate Friendly Products</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6 d-grid">
                                    <div className="center bg-secondary pattern-2 w-100 pt-5">
                                        <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/trees1_bdh6gb.svg`} /></div>
                                        <div className="px-2 pt-2">
                                            <h3 className="font-bold">{treeGrowthYears}</h3>
                                            <p className="mt-0 font-bold"><span className="mr-2">Tree Growth Years</span>
                                                <Popover content={treeMetric} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                    </svg>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-md-4 col-sm-6 d-grid">
                                    <div className="center bg-secondary pattern-2 w-100 pt-5">
                                        <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/2974393_engine_mill_turbine_wind_windmill_icon_1_wzlgf5.svg`} /></div>
                                        <div className="px-2 pt-2">
                                            <h3 className="font-bold">99%</h3>
                                            <p className="mt-0 font-bold"> Carbon imprint savings using wind power</p>
                                            <p className="mt-4 sml">19% Reduction in electricity <br/>(kWh) offset by windpower YoY.<br/>That's enough energy to produce <br/>926,180 bags of treats!</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6 d-grid">
                                    <div className="center bg-secondary pattern-2 w-100 pt-5">
                                        <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/Group635_c87lcb.svg`} /></div>
                                        <div className="px-2 pt-2">
                                            <h3 className="font-bold">11%</h3>
                                            <p className="mt-0 font-bold"> Reduction in gas <br/>from 2019 to 2020</p>
                                            <p className="mt-4 sml">That’s like recycling <br/>9,200lbs of poop bags!</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6 d-grid">
                                    <div className="center bg-secondary pattern-2 w-100 pt-5">
                                        <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587609/Enterprise/inclover/Group_z9ir5n.svg`} /></div>
                                        <div className="px-2 pt-2">
                                            <h3 className="font-bold">40%</h3>
                                            <p className="mt-0 font-bold">Reduction in water usage from 2019 to 2020</p>
                                            <p className="mt-4 sml">You could fill 273,386 <br/>water bowls with that!</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-show py-3 mt-5 text-center">
                    <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                        <div key="1">
                            <div className="center bg-secondary pattern-2 w-100">
                                <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587366/Enterprise/inclover/cloudy1_r7lsn5.svg`} /></div>
                                <div className="px-2 pt-2 pb-5">
                                    <h3 className="font-bold">{carbonOffsetImpact}</h3>
                                    <p className="mt-0 font-bold">{carbonOffsetImpactUnit}, of CO2 Offset</p>
                                </div>
                            </div>
                        </div>

                        <div key="2">
                            <div className="center bg-secondary pattern-2 w-100">
                                <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/pet1_oqxzin.svg`} /></div>
                                <div className="px-2 pt-2 pb-5">
                                    <h3 className="font-bold">{numberOfProducts}</h3>
                                    <p className="mt-0 font-bold">Climate Friendly Products</p>
                                </div>
                            </div>
                        </div>

                        <div key="3"> 
                            <div className="center bg-secondary pattern-2 w-100">
                                <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/trees1_bdh6gb.svg`} /></div>
                                <div className="px-2 pt-2 pb-5">
                                    <h3 className="font-bold">{treeGrowthYears}</h3>
                                    <p className="mt-0 font-bold"><span className="mr-2">Tree Growth Years</span>
                                        <Popover content={treeMetric} >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                            </svg>
                                        </Popover>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div key="4">
                            <div className="center bg-secondary pattern-2 w-100">
                                <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/2974393_engine_mill_turbine_wind_windmill_icon_1_wzlgf5.svg`} /></div>
                                <div className="px-2 pt-2 pb-5">
                                    <h3 className="font-bold">99%</h3>
                                    <p className="mt-0 font-bold"> Carbon imprint savings using wind power</p>
                                    <p className="mt-4 sml">19% Reduction in electricity <br/>(kWh) offset by windpower YoY.<br/>That's enough energy to produce <br/>926,180 bags of treats!</p>
                                </div>
                            </div>
                        </div>

                        <div key="5">
                            <div className="center bg-secondary pattern-2 w-100">
                                <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587607/Enterprise/inclover/Group635_c87lcb.svg`} /></div>
                                <div className="px-2 pt-2 pb-5">
                                    <h3 className="font-bold">11%</h3>
                                    <p className="mt-0 font-bold"> Reduction in gas <br/>from 2019 to 2020</p>
                                    <p className="mt-4 sml">That’s like recycling <br/>9,200lbs of poop bags!</p>
                                </div>
                            </div>
                        </div>

                        <div key="6">
                            <div className="center bg-secondary pattern-2 w-100">
                                <div className="borderImage"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628587609/Enterprise/inclover/Group_z9ir5n.svg`} /></div>
                                <div className="px-2 pt-2 pb-5">
                                    <h3 className="font-bold">40%</h3>
                                    <p className="mt-0 font-bold">Reduction in water usage from 2019 to 2020</p>
                                    <p className="mt-4 sml">You could fill 273,386 <br/>water bowls with that!</p>
                                </div>
                            </div>
                        </div>
                    </Carousel>
                </div>
            </div>
         

            <div className="d-flex">
                <div className="container text-center">
                    <img className="w-100" src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628588625/Enterprise/inclover/Clover_illustration_1080_x_2000px_copy-1_1_tcjimn.jpg`}/>
                </div>
            </div>

            <div className="py-6">
                <div className="container text-center">
                    <div>
                        <h2 className="font-bold">It Takes a Tribe</h2>
                        <p className="text-grey mb-0 font-22">If not for the amazing support systems and partnerships we’ve developed over the past <br/>25 years, we wouldn’t be company we are today.<br/>Here are just a few of the organizations that help keep our tails wagging</p>
                        <div className="row text-align-start justify-content-center imgProject">

                            <div className="col-lg-5 col-md-6">
                                <div className="center bg-secondary pattern-2 w-100 pt-4 d-grid h-100">
                                    <div className="borderImage big bg-black"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628590753/Enterprise/inclover/image_92_uopj3k.svg`} /></div>
                                    <div className="px-2 pt-2">
                                        <h3 className="font-bold mt-3">Imagine</h3>
                                        <p className="mt-4 sml px-4">Imagine! provides services designed to incorporate <br/>people with developmental, cognitive, and physical <br/>challenges into the fabric of their communities. <br/>Services include educational and therapeutic <br/>services, job training and placement, recreation and <br/>leisure activities, opportunities for community living, <br/>behavioural health services, technology solutions, <br/>and support for families.</p>
                                    </div>
                                    <div className="self-end"><a href="https://imaginecolorado.org/" className="btn btn-green a-sml font-bold">Learn More</a></div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6">
                                <div className="center bg-secondary pattern-2 w-100 pt-4 d-grid h-100">
                                    <div className="borderImage big mt-2"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628590753/Enterprise/inclover/image_93_wngux5.svg`} /></div>
                                    <div className="px-2 pt-2">
                                        <h3 className="font-bold mt-3">Project V.E.T.S.</h3>
                                        <p className="mt-4 sml px-4">Project V.E.T.S. is a Boulder, Colorado based <br/>501(c)(3) organization dedicated to improving <br/>the health and welfare of animals around the <br/>world to veterinarians working in non - profit or <br/>non - governmental organizations devoted to <br/>animal health. In this way InClover, in<br/> partnership with Project V.E.T.S. helps animals <br/>around the world while conserving valuable <br/>resources that might otherwise end up in a <br/>landfill.</p>
                                    </div>
                                    <div className="self-end"><a href="https://www.projectvets.org/" className="btn btn-green a-sml font-bold">Learn More</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <section className="iframeSec">
                <div className="container-fluid px-0">
                <h2 className="text-center font-600 mb-4">Do you want to learn more about your environmental impact? <br/>Begin your journey by understanding your carbon footprint</h2>
                <iframe id="PersonalCalculator" className="calculator-iframe  d-flex flex-wrap" src={process.env.MY_CC_URL + '/personal-calculator-embed?merchantCode='+ merchantCode}></iframe>
                </div>
            </section>
            {Array.isArray(projects) &&
                <div className="py-6 projectSec">
                    <div className="container text-center">
                        <div>
                            <div className="mb-5 center text-white">
                                <h2 className="font-bold">$0.05 of Every InClover Purchase Supports Projects That <br/>Fight Climate Change</h2>
                                <p className="projecDes">There’s a big wide world outside our small Boulder, CO bubble and we want to see it thrive.</p>
                                <p className="projecDes">
                                As part of our commitment to supporting the health of people pets and our planet, $0.05 <br/>from every InClover purchase goes toward supporting these projects that fight climate <br/>change and protect our planet.</p>
                            </div>
                            <div className="text-align-start mobile-text-center">
                                <ProjectsScroll title={null} projects={projects} />
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="py-6 faqSec">
                <div className="container text-center">
                    <h3 className="font-bold mb-4">Climate Friendly Product FAQs</h3>
                    <div className="mb-3 center text-align-start mw-800px">
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"What are carbon credits?"} >A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.</Accordian>
                        <Accordian title={"How are emissions calculated?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>                        
                    </div>
                    <a href="https://www.carbonclick.com/faq/" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg font-bold" >View All</a>
                </div>
            </div>

            <div className="w-100 img-cover footer-img py-6 bg-primary text-white" >
                <div className="container py-5">
                    <div>
                        <p className="font-12"><b>Powered by</b></p>
                        <div className="d-flex">
                            <div>
                                <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                    <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                                </a>
                            </div>
                            <div className="right">
                                <div>
                                    <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                        <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                    </a>
                                    <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                        <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                    </a>
                                    <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                        <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <hr className="mb-4" />

                        <div className="row justify-content-between fLinks">
                            <div className="col-md-auto">
                                <div>
                                    <div className="mb-3"><a className="text-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                                    <div className="mb-3"><a className="text-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                </div>
                            </div>
                            <div className="col-md-auto">
                                <div>
                                    <div className="mb-3"><a className="text-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                    <div className="mb-3"><a className="text-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                                </div>
                            </div>
                            <div className="col-md-auto">
                                <div>
                                    <div className="mb-3"><a className="text-white" href="mailto:hello+inclover@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;